import "./styles/main.css";

import AllAlertsContainer from "./components/AllAlertsContainer";
import Box from "@mui/material/Box";
import GasLeakChartContainer from "./components/GasLeakContainer";
import Grid from "@mui/material/Grid";
import MostActiveLocationsContainer from "./components/MostActiveLocationsContainer";
import PPEInfractionsContainer from "./components/PPEInfractionsContainer";
import VisitorsContainer from "./components/VisitorsContainer";
import { useGetCustomer } from "../../../../common/hooks/useGetCustomer";

const SystemPerformanceTab = (): JSX.Element => {
  const { customer, loading } = useGetCustomer();

  const showGasLeakChart = !customer?.isQuantificationsDisabled && !loading;

  return (
    <Box
      sx={{
        gap: "1.5em 1.5em",
        display: "grid",
      }}
    >
      <Grid container alignItems="center" justifyContent="center" spacing={3}>
        <Grid item xs={12} sm={12}>
          <AllAlertsContainer />
        </Grid>
        {showGasLeakChart && (
          <Grid item xs={12} md={12} lg={6}>
            <GasLeakChartContainer />
          </Grid>
        )}
        <Grid item xs={12} md={12} lg={6}>
          <PPEInfractionsContainer />
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <VisitorsContainer />
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <MostActiveLocationsContainer />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SystemPerformanceTab;
